const env =
  window.location.hostname === "localhost"
    ? "local"
    : process.env.BUILD_ENV || process.env.REACT_APP_BUILD_ENV;

// GA4 measurement ID 放在各環境設定裡，之後可個別替換。目前 dev / test 還沒有獨立的 GA property，
// 所以各環境暫時都填同一個正式 ID，由後端同步時以 hostname 過濾（含 localhost）。
const GA_MEASUREMENT_ID = "G-B17J6K0VSN";

const SERVER = {
  local: {
    SERVER_URL: "https://ar-api-dev.istaging.com",
    JSON: "https://jsonplaceholder.typicode.com",
    GET_DOMAIN: "localhost",
    GA_MEASUREMENT_ID,
    PLATFORM_URL: "http://localhost:3022",
  },
  development: {
    SERVER_URL: "https://ar-api-dev.istaging.com",
    JSON: "https://jsonplaceholder.typicode.com",
    GET_DOMAIN: "arviewer-dev.istaging.com",
    GA_MEASUREMENT_ID,
    PLATFORM_URL: "https://armaker-dev.istaging.com",
  },
  test: {
    SERVER_URL: "https://ar-api-test.istaging.com",
    JSON: "https://jsonplaceholder.typicode.com",
    GET_DOMAIN: ".istaging.com",
    GA_MEASUREMENT_ID,
  },
  production: {
    SERVER_URL: "https://ar-api.istaging.com",
    JSON: "https://jsonplaceholder.typicode.com",
    GET_DOMAIN: "arviewer.istaging.com",
    GA_MEASUREMENT_ID,
    PLATFORM_URL: "https://armaker.istaging.com",
  },
};

export default SERVER[env];
